export const sourceSchema = {
  type: "object",
  properties: {
    PatientActivityID: {
      type: "string",
    },
    PatientActivityName: {
      type: ["string", "null"],
    },
    PatientID: {
      type: ["string", "null"],
    },
    PatientName: {
      type: ["string", "null"],
    },
    PatientLastName: {
      type: ["string", "null"],
    },
    PatientFirstName: {
      type: ["string", "null"],
    },
    PatientFamilyReferenceID: {
      type: ["string", "null"],
    },
    ActivityStatus: {
      type: "integer",
    },
    ActivityType: {
      type: "integer",
    },
    IsPartialSaveEnabled: {
      type: "boolean",
    },
    LastUpdatedPageNumber: {
      type: "integer",
    },
    PreferredLanguage: {
      type: "integer",
    },

    PatientActivityDetails: {
      type: "array",
      items: {
        type: "object",
        properties: {
          PatientActivityDetailID: {
            type: "string",
          },
          PatientActivityDetailName: {
            type: "string",
          },
          PatientActivityID: {
            type: "string",
          },
          QuestionType: {
            type: "integer",
          },
          Question: {
            type: "string",
          },
          Choices: {
            type: "array",
            items: {
              choiceCode: {
                type: "string",
              },
              choiceText: {
                type: "string",
              },
            },
          },
          ChoicesText: {
            type: "string",
          },
          AnswerCodes: {
            type: ["string", "null", "array"],
          },
          EnglishChoice: {
            type: ["string", "null", "array"],
          },
          ColumnType: {
            type: "integer",
          },
          Response: {
            type: ["string", "null", "array"],
          },
          EnglishResponse: {
            type: ["string", "null", "array"],
          },
          QuestionDocuments: {
            type: ["string", "null", "array"],
          },
          ResponseText: {
            type: ["string", "null", "array"],
          },
          ColumnDataType: {
            type: "integer",
          },
          Description: {
            type: ["string", "null"],
          },
          IsOtherEnabled: {
            type: "boolean",
          },
          OtherResponse: {
            type: ["string", "null"],
          },
          IsMandatory: {
            type: "boolean",
          },
          PageNumber: {
            type: "integer",
          },
          QuestionNumber: {
            type: "integer",
          },
          QuestionCode: {
            type: ["string", "null"],
          },
          ResponseCode: {
            type: ["string", "null", "array"],
          },
          ChildQuestionNumber: {
            type: "integer",
          },
          EnableChildOnResponse: {
            type: ["string", "null"],
          },
          ValidationSetting: {
            type: ["string", "null"],
          },
          IsPartialSaveEnabled: {
            type: "boolean",
          },
          CompletionStatus: {
            type: "integer",
          },
          FieldDelimiter: {
            type: ["string", "null"],
          },
          IsNoneOfTheAboveEnabled: {
            type: "boolean",
          },
          NoneOfTheAboveText: {
            type: ["string", "null"],
          },
          AdditionalSetting: {
            type: ["string", "null"],
          },
        },
        required: ["PatientActivityDetailID"],
      },
    },
  },
  required: ["PatientActivityID"],
};
export const parsedSchema = {};
export const expression_parseFromSource =
  "{" +
  '"activityId":PatientActivityID,' +
  '"activityName":PatientActivityName,' +
  '"activityStatus":ActivityStatus,' +
  '"activityType":ActivityType,' +
  '"lastUpdatedPageNumber": LastUpdatedPageNumber,' +
  '"PreferredLanguage": PreferredLanguage,' +
  '"member":{' +
  '"id":PatientID,' +
  '"formatedValue": PatientName,' +
  '"entity": ""' +
  "}," +
  '"isPartialSaveEnabled": IsPartialSaveEnabled,' +
  '"pages" : $distinct(PatientActivityDetails.{' +
  '"pageNumber" : PageNumber,' +
  '"saveOnNav" : false,' +
  '"questionGroups" : [{' +
  '"questionGroupId": "g1",' +
  '"questionGroup": "Qus Group",' +
  '"questionSection": "Qus Sec",' +
  '"questionSubSection": "Qus SubSection"  ,' +
  '"questions" : $filter($$.PatientActivityDetails[*], function($item) {$item.PageNumber = PageNumber})[].{' +
  '"id": PatientActivityDetailID,' +
  '"PatientActivityDetailID": PatientActivityDetailID,' +
  '"questionNumber": QuestionNumber,' +
  '"questionCode": QuestionCode,' +
  '"responseCode": ResponseCode,' +
  '"questionText": Question,' +
  '"questionType": QuestionType,' +
  '"responseType": QuestionType, ' +
  '"responseDataType": ColumnDataType,' +
  '"response": Response ? Response : null,' +
  '"fielddelimiter": FieldDelimiter,' +
  '"QuestionTextCode": QuestionTextCode,' +
  '"ChoicesTextCode": ChoicesTextCode,' +
  '"questionDocuments": QuestionDocuments,' +
  '"answerCodes": AnswerCodes,' +
  '"englishChoice": [EnglishChoice.choiceText],' +
  '"englishResponse": EnglishResponse ? EnglishResponse : null,' +
  '"choices": [Choices.' +
  " {" +
  '"choiceCode": choiceCode,' +
  '"choiceText": choiceText,' +
  '"choiceTextInDefaultLanguage": choiceTextInDefaultLanguage,' +
  '"scoringValue": scoringValue,' +
  '"choiceOrder": choiceOrder' +
  "  }]," +
  '"completionStatus":CompletionStatus,' +
  '"hasOthers":IsOtherEnabled,' +
  '"othersResponse": OtherResponse,' +
  '"hasNOA":IsNoneOfTheAboveEnabled,' +
  '"noaText":NoneOfTheAboveText,' +
  '"isRequired":IsMandatory,' +
  '"isPartialSaveEnabled":IsPartialSaveEnabled,' +
  '"validationSetting":"",' +
  '"AdditionalSetting":AdditionalSetting,' +
  '"sectionName":SectionName,' +
  '"subSectionName":SubSectionName,' +
  '"isVisible":false,' +
  '"hasVisibilityRule":  ( ChildQuestionNumber ) ? true:false,' +
  '"visibilityRule":( EnableChildOnResponse) ? { "conditionType": 120000001,' +
  '"conditionOperator": 1,' +
  '"compareOperator": 120000000,' +
  '"fieldCondition": {' +
  '"questionNumber": ChildQuestionNumber,' +
  '"answerCode": EnableChildOnResponse' +
  " }," +
  '"filterConditions": null,' +
  '"conditionOutput": true}:null ,' +
  '"description":Description' +
  "}" +
  "}]" +
  "}).$[]" +
  "}";

export const response_type_map = {
  0: "txt",
  120000000: "sing",
  120000001: "mul",
  120000002: "txt",
  120000003: "mxtxt",
  120000004: "dropdown",
  120000005: "usDropdown",
  120000006: "address",
  120000007: "emoji",
  120000008: "",
};
